/** @format */

import { CommonModule } from '@angular/common';
import { HomefieldColorSwatchModule } from '../../color-swatch';
import { HomefieldProductCardColorSwatchesComponent } from './product-card-color-swatches.component';
// Components
import { HomefieldTextLinkModule } from '../../text-link';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [HomefieldProductCardColorSwatchesComponent],
  imports: [CommonModule, HomefieldColorSwatchModule, HomefieldTextLinkModule],
  exports: [HomefieldProductCardColorSwatchesComponent],
})
export class HomefieldProductCardColorSwatchesModule {}
